var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":true,"absolute":""}},[_c('div',{staticClass:"d-flex flex-column align-center"},[_c('v-progress-circular',{attrs:{"size":50,"indeterminate":""}}),_c('div',[_vm._v("Верификация email")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }